import { render, staticRenderFns } from "./UserEditQuickText.vue?vue&type=template&id=17d8023f&"
import script from "./UserEditQuickText.vue?vue&type=script&lang=js&"
export * from "./UserEditQuickText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports